import { apiRequest, helpdeskServiceCreate } from "../../../../services/adapters/base";

class CreateRepository {
  fetchCreate = async (query) => {
    return await apiRequest(
      "post",
      helpdeskServiceCreate,
      {
        body: query,
      },
      true
    );
  };
}

export default CreateRepository;
